export default {
    install (Vue) {
        Vue.prototype.apiErrorMessageHandler = function(error) {
            if (error.response && error.response.data && error.response.data.msg) {
                this.$toasted.global.general_error({message: error.response.data.msg});
            } else {
                this.$toasted.global.general_error();
            }
        }
        Vue.prototype.apiSaveSuccessMessageHandler = function() {
            this.$toasted.global.save_success();
		}
	}
}